import React from 'react';
import PrimaryButton from 'app/views/components/buttons/PrimaryButton';

interface StepperFooterProps {
    onSaveAndExit: () => void;
    onSaveAndProceed?: () => void;
    onPrevious?: () => void;
    onClose: () => void;
    loading?: boolean;
    showSaveAndProceed?: boolean;
    showPrevious?: boolean;
    saveAndProceedLabel?: string;
    disableSave?: boolean;
}

export default function StepperFooter({
    onSaveAndExit,
    onSaveAndProceed,
    onPrevious,
    onClose,
    loading = false,
    showSaveAndProceed = true,
    showPrevious = true,
    saveAndProceedLabel = "Save and Proceed",
    disableSave = false,
}: StepperFooterProps) {
    return (
        <div className="facility-stepper-footer">
            <div className="facility-stepper-button-group">
                <PrimaryButton
                    onClick={onSaveAndExit}
                    className="facility-stepper-button"
                    loading={loading}
                    disabled={disableSave}
                >
                    Save and Exit
                </PrimaryButton>
                {showSaveAndProceed && onSaveAndProceed && (
                    <PrimaryButton
                        onClick={onSaveAndProceed}
                        className="facility-stepper-button"
                        loading={loading}
                        disabled={disableSave}
                    >
                        {saveAndProceedLabel}
                    </PrimaryButton>
                )}
                {showPrevious && onPrevious && (
                    <PrimaryButton
                        onClick={onPrevious}
                        className="facility-stepper-button"
                        loading={loading}
                    >
                        Previous
                    </PrimaryButton>
                )}
                <PrimaryButton
                    onClick={onClose}
                    className="facility-stepper-button"
                    loading={loading}
                >
                    Close
                </PrimaryButton>
            </div>
        </div>
    );
}